import { MatDateFormats } from '@angular/material/core';

/**
 * Standard date formats for Day.js date adapter.
 * Used with Material datepicker components.
 */
export const DAYJS_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

/**
 * Extended date and time formats for Day.js date adapter.
 * Used with custom mat-datetime component that supports both date and time selection.
 *
 * Supports multiple input formats:
 * - YYYY-MM-DD HH:mm: Standard datetime format
 * - LLL: Locale-specific long date (e.g., "January 15, 2024 3:30 PM")
 * - LL: Locale-specific short date (e.g., "January 15, 2024")
 */
export const DAYJS_DATETIME_FORMATS: MatDateFormats = {
  parse: {
    dateInput: ['YYYY-MM-DD HH:mm', 'LLL', 'LL'],
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'LLL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LLL',
    monthYearA11yLabel: 'MMMM YYYY',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  }
};
